/* eslint-disable object-shorthand */
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getWidgetPerfInfo,
    PerformanceWidgetPerfs,
    WidgetInfoPerfParameter,
    WidgetInfoPerfPrintParameter,
} from "@tecumseh/Services/PerformanceWidgetService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type WidgetInfoHandlerType = CustomApiHandler<WidgetInfoPerfPrintParameter, PerformanceWidgetPerfs[]>;

export const RequestWidgetPerfs: WidgetInfoHandlerType = async props => {

    const state = props.getState();
    const widgetinfo = state.customPerformanceWidgetInfo.widgetInfo;
    const newArray: { model: string; type: number; application: string; fluide: any; frequency: any; mid: boolean; }[] = [];

    props.parameter.selectedRefrigerants.forEach((refrigerant: any) => {
        props.parameter.selectedFrequencies.forEach((frequency: any) => {
            if (widgetinfo) {
                const refrigerantInfo = widgetinfo.fluides.find(r => r.refrigerant === refrigerant.refrigerant);
                const isMid = refrigerantInfo?.def_Cond === "Mid";
                newArray.push({
                    model: widgetinfo.globalModel,
                    type: widgetinfo.productType,
                    application: widgetinfo.applicationID,
                    fluide: refrigerant.refrigerant,
                    frequency: frequency,
                    mid: isMid,
                });
            }
        });
    });
    const apiCalls = newArray.map(async (data) => {
        const result = await getWidgetPerfInfo(data); // Assuming getWidgetPerfInfo is an async function.
        return result;
    });

    try {
        props.apiResult = await Promise.all(apiCalls);

    } catch (error) {
        // Handle error here
        console.error(error);
        return false;
    }
};

export const DispatchBeginWidgetPerfs: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/BeginLoadPrintWidgetPerfs",
    });
};

export const WidgetPerfsCompleted: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/CompletePrintPerfromanceWidgetPerfs",
        widgetPerfs: props.apiResult,
        selectedComb: {
            selectedRef: props.parameter.selectedRefrigerants,
            selectedFreq: props.parameter.selectedFrequencies
        }
    });
};

export const widgetPerfsChain = [DispatchBeginWidgetPerfs, RequestWidgetPerfs, WidgetPerfsCompleted];

const loadPerformanceWidgetPerfsForPrint = createHandlerChainRunner(
    widgetPerfsChain,
    "LoadPerformanceWidgetPerfsForPrint",
);

export default loadPerformanceWidgetPerfsForPrint;